import Service from "./service"
import { ActionContext } from "vuex"

const login = async (
  { commit }: any,
  obj: { email: string; password: string }
) => {
  return Service()
    .signIn(obj)
    .then(async (result: { data: object }) => {
      await commit("signIn", result.data)
    })
}

const getProfile = async ({ commit }: ActionContext<any, any>) => {
  return Service()
    .profile()
    .then((result: any) => {
      commit("save_profile", result.data)
    })
}

const logout = async ({ commit }: any) => {
  await commit("logout")
}
export default { login, logout, getProfile }
